export const ACCEPTED_SOURCE_APPS = Object.freeze({
  WORKFLOWS_CLASSIC: 'WORKFLOWS_CLASSIC',
  WORKFLOWS_APP: 'WORKFLOWS_APP',
  FORM_FIELD_FOLLOWUP: 'FORM_FIELD_FOLLOWUP',
  CMS_FORM_MODULE_FIELD: 'CMS_FORM_MODULE_FIELD'
});
export const SIMPLE_WORKFLOW_SOURCE_APP = 'FORMS_APP';